import useApi, { ApiOptions } from '../base/useApi';
import UserBookingAvailabilityDTO from '@src/adapters/dto/user/UserBookingAvailabilityDTO';

interface Params {
  assignments: { availabilityId: string; jobId: string }[];
  pencilConfirmIds: string[];
}

interface Result {
  updatedAvailabilities: UserBookingAvailabilityDTO[];
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/job/save_bookings',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveBookingsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveBookingsLazy;
